var messages = {
  title: 'Click to open'
};
export default messages;